import { render } from "./Despatch.vue?vue&type=template&id=5d9783e4"
import script from "./Despatch.vue?vue&type=script&lang=js"
export * from "./Despatch.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__